
import React from 'react'

import moment from 'moment'

import {  Table, Space} from "antd";


export default function DailySubTable({ data, loading }) {

    const columns = [
        {
            title: 'Giorni',
            dataIndex: 'key_as_string',
            key: 'key_as_string',
            render: (text, row) => (
                <Space size="middle" key={row.key_as_string}>
                    <p>{moment(row.key_as_string).format("DD MMMM YYYY")}</p>
                </Space>
            ),
        },
        {
            title: 'Num. trans.',
            dataIndex: 'quantita',
            key: 'quantita',
            render: (text, row) => (
                <Space size="middle" key={row.key_as_string}>
                    <p>{row.quantita}</p>
                </Space>
            ),
        },
        {
            title: 'Spesa media',
            dataIndex: 'prezzo_medio',
            key: 'prezzo_medio',
            render: (text, row) => (
                <Space size="middle" key={row.key_as_string}>
                    {row.prezzo_medio ? <p>{row.prezzo_medio.toFixed(2)}</p> : <p>non calcolato</p>}
                </Space>
            ),
        },
        {
            title: 'Valore',
            dataIndex: 'valore',
            key: 'valore',
            render: (text, row) => (
                <Space size="middle" key={row.key_as_string}>
                    <b>{(row.valore).toFixed(2)}</b>
                </Space>
            ),
        },
    ];


    if (loading) return <p> sto caricando ... </p>

    return <Table columns={columns}
        dataSource={data}
        pagination={true} />;

} 
